<template>
  <v-app>
    <nav-gation></nav-gation>
    <v-content class="secondary main-viewport">
      <v-container fluid class="secondary">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Vue from "vue";
import { auth } from "./vue-service-auth";
import NavItems from "./components/NavItems.vue";
import Navigation from "./components/Navigation.vue";
import guard from "./router/guard";
import store from "@/store/";
import { setUserAsSelectedPerson } from "./vue-service-selected_person";
import {
  peopleRef,
  administratorsRef,
  groupsRef,
  membershipsRef,
  usersRef,
  technologyRef,
  birthdaysThisMonthRef,
  anniversariesThisMonthRef,
  skillsRatingRef
} from "@/vue-service-database";
import {
  syncApis,
  postToday,
  updatePersonsGSuiteStatus,
  postGroupsData,
  postOnsipUsers,
  postSlackActiveUsers,
  updateSlackActiveUsersPublicChannels,
  setDate,
  postUpdateSheet
} from "./vue-service-api";
import {
  addFullName
} from "./vue-service-person";
export default {
  name: "app",
  components: {
    "nav-items": NavItems,
    "nav-gation": Navigation
  },
  computed: {
    authenticated() {
      return this.$store.getters.authenticated;
    },
    user() {
      return this.$store.getters.user;
    },
    administrator() {
      return this.$store.getters.administrator;
    }
  },
  created: function() {
    /* EVENT LISTENERS */
    // Listen for changes to the users auth state
    auth.onAuthStateChanged(user => {
      if (user != null) {
        // Update the store
        this.$store.dispatch("SET_AUTHORIZED", user);
        this.$store.dispatch("SET_USER", user);
        this.$store.dispatch("SET_ADMINISTRATOR", {
          user,
          administratorsEmail: administratorsRef // WHAT?? <<
        });
        
        // Get a token to validate Firebase API request
        user.getIdToken().then(token => {
          this.$store.dispatch("SET_TOKEN", token);

          // Ask firebase functions to get data
          // from external services via their apis
          syncApis();
          postToday();
          updatePersonsGSuiteStatus();
          postGroupsData();
          postOnsipUsers();
          postSlackActiveUsers();
          updateSlackActiveUsersPublicChannels();
        });

        // The user will see their own info when the app starts

        setUserAsSelectedPerson(user);


        // Log the user.email and timestamp in the Database
        // ?? This should be a cloud functions ??
        // !! TODO: Clean up this log above (it's filling up Firebase)
        const date = new Date();
        usersRef.push({ email: user.email, time: date.getTime() });
      } else {
        console.log("auth.currentUser :", auth.currentUser);
        // No user/auth so update the store to revoke access
        store.dispatch("SET_AUTHORIZED", false);
        // Remove user data from the store
        store.dispatch("SET_USER", false);
        // Send to signin page
        this.$router.push("/");
      }
    });
    let promises = [];
    // Listen to the realtime database and
    // update the store when it changes
    const p = peopleRef.on("value", snapshot => {
      console.log("Loaded people");
      const value = snapshot.val();
      this.$store.dispatch("SET_PEOPLE", value);
    });
    promises.push(p);
    const g = groupsRef.on("value", snapshot => {
      const value = snapshot.val();
      this.$store.dispatch("SET_GROUPS", value);
    });
    promises.push(g);
    const m = membershipsRef.on("value", snapshot => {
      const value = snapshot.val();
      this.$store.dispatch("SET_MEMBERSHIPS", value);
    });
    promises.push(m);
    const a = administratorsRef.on("value", snapshot => {
      console.log("Loaded admins");
      this.$store.dispatch("SET_ADMINISTRATOR", {
        user: this.$store.getters.user,
        administratorsEmail: administratorsRef
      });
    });
    promises.push(a);
    const b = birthdaysThisMonthRef.on("value", snapshot => {
      console.log("Loaded birthdays")
      let value = snapshot.val();
      this.$store.dispatch("SET_BIRTHDAYS_THIS_MONTH", value);
    });
    promises.push(b);
    const an = anniversariesThisMonthRef.on("value", snapshot => {
      console.log("Loaded anniversaries")
      let value = snapshot.val();
      this.$store.dispatch("SET_ANNIVERSARIES_THIS_MONTH", value);
    });
    promises.push(an);
    skillsRatingRef.child("byTechnology").once("value", snapshot => {
      console.log("Loaded skill ratings");
      const value = snapshot.val();
      this.$store.dispatch("SET_SKILLS_RATING_BY_TECHNOLOGY", value);
    });
    const s = skillsRatingRef.child("byPerson").on("value", snapshot => {
      console.log("Loaded skills ratings")
      const skillsRatingByPerson = snapshot.val();
      //console.log("skillsRatingByPerson", skillsRatingByPerson)
      this.$store.dispatch("SET_SKILLS_RATING_BY_PERSON", skillsRatingByPerson);
    });
    promises.push(s);
    const t = technologyRef.on("value", snapshot => {
      console.log("Loaded technology");
      const value = snapshot.val();
      this.$store.dispatch("SET_TECHNOLOGY", value);
    });
    promises.push(t);
    return Promise.all(promises);
  }
};
</script>

<style>
/* style the userImage to fit in nav */
.toolbar-title-img {
  max-width: 35px;
  border-radius: 50%;
}

.main-viewport {
  margin-left: 80px;
  margin-top: 64px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue